import { inject, ref } from 'vue'
import handleBudgetTracker from '@/services/modules/procurement/budgetTracker'
import { downloadBlob, toCapitalizeFirst } from '@/services/utils/global.js'

export default function useBudgetVersionExport(getCompanyId) {
    const showError = inject('showError')
    const { exportBudgetVersion } = handleBudgetTracker()

    const exportingVersionId = ref(null)

    const fileName = (budgetName, version) => {
        const safeName = String(budgetName || 'Budget').replace(/[\\/]/g, '-')
        return `Budget - ${safeName} - V${version.version_no} (${toCapitalizeFirst(version.status)}).xlsx`
    }

    const saveOrExplain = async (blob, name) => {
        if (! blob.type.includes('json')) {
            downloadBlob(blob, name)
            return
        }

        const response = JSON.parse(await blob.text())

        showError(response.message)
    }

    const exportVersion = async (budgetId, budgetName, version) => {
        if (exportingVersionId.value) return

        exportingVersionId.value = version.id

        try {
            const response = await exportBudgetVersion(budgetId, version.id, `?company_id=${getCompanyId()}`)

            await saveOrExplain(response.data, fileName(budgetName, version))
        } catch (error) {
            showError('Something went wrong. Please try again.')
        } finally {
            exportingVersionId.value = null
        }
    }

    return {
        exportingVersionId,
        exportVersion,
    }
}
